import React from 'react'
import { IconType } from 'components/patterns/themes/components/ThemedIcon'

export const LowRateIcon = (): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24.285" height="24.201" viewBox="0 0 24.285 24.201">
		<g>
			<path
				fill="#592b86"
				stroke="#592b86"
				strokeWidth="0.2px"
				d="M12.913.914a1.182 1.182 0 0 0-.754.265l-1.826 1.478a.391.391 0 0 1-.313.084L7.7 2.372a1.2 1.2 0 0 0-1.3.754l-.843 2.2a.4.4 0 0 1-.229.229l-2.2.843a1.2 1.2 0 0 0-.754 1.3l.369 2.323a.4.4 0 0 1-.084.313L1.178 12.16a1.2 1.2 0 0 0 0 1.507l1.479 1.828a.391.391 0 0 1 .084.313l-.369 2.322a1.2 1.2 0 0 0 .754 1.3l2.2.841a.4.4 0 0 1 .229.231l.838 2.198a1.2 1.2 0 0 0 1.3.754l2.323-.368a.4.4 0 0 1 .313.084l1.826 1.479a1.2 1.2 0 0 0 1.507 0l1.828-1.479a.4.4 0 0 1 .313-.086l2.323.369a1.2 1.2 0 0 0 1.3-.754l.841-2.2a.407.407 0 0 1 .231-.229l2.194-.841a1.2 1.2 0 0 0 .754-1.3l-.368-2.323a.4.4 0 0 1 .084-.313l1.479-1.826a1.2 1.2 0 0 0 0-1.508l-1.479-1.826a.393.393 0 0 1-.084-.313l.375-2.32a1.2 1.2 0 0 0-.754-1.3l-2.194-.843a.4.4 0 0 1-.229-.229l-.843-2.2a1.206 1.206 0 0 0-1.3-.754l-2.323.369a.4.4 0 0 1-.313-.084l-1.83-1.48a1.194 1.194 0 0 0-.754-.265z"
				transform="translate(.143 .1) translate(-.913 -.914)"
			/>
			<path
				fill="#fff"
				stroke="#fff"
				strokeWidth="0.5px"
				d="M17.716 8.128a.593.593 0 0 0-.565.312l-6.412 12.823a.584.584 0 0 0 1.034.542l6.412-12.823a.585.585 0 0 0-.246-.788.627.627 0 0 0-.223-.066zm-7.043 1.166a1.752 1.752 0 0 0-1.749 1.749v1.749a1.752 1.752 0 0 0 1.749 1.749h.583A1.752 1.752 0 0 0 13 12.791v-1.749a1.752 1.752 0 0 0-1.749-1.749zm0 1.166h.583a.584.584 0 0 1 .583.583v1.749a.584.584 0 0 1-.583.583h-.583a.584.584 0 0 1-.583-.583v-1.75a.584.584 0 0 1 .583-.583zm6.994 5.246a1.752 1.752 0 0 0-1.749 1.749V19.2a1.752 1.752 0 0 0 1.749 1.749h.583A1.752 1.752 0 0 0 20 19.2v-1.746a1.752 1.752 0 0 0-1.749-1.749zm0 1.166h.583a.584.584 0 0 1 .583.583V19.2a.584.584 0 0 1-.583.583h-.583a.584.584 0 0 1-.583-.583v-1.746a.584.584 0 0 1 .584-.583z"
				transform="translate(.143 .1) translate(-2.661 -3.123)"
			/>
		</g>
	</svg>
)

export const MorePurposesIcon: IconType = ({ primaryFill }) => (
	<svg xmlns="http://www.w3.org/2000/svg" id="icon-plus" width="48" height="48" viewBox="0 0 48 48">
		<defs>
			<style>{`.cls-1{fill:none;stroke:${primaryFill};stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}`}</style>
		</defs>
		<path id="Line_25" d="M0 0L0 36" className="cls-1" transform="translate(24 6)" />
		<path id="Line_26" d="M0 0L36 0" className="cls-1" transform="translate(6 24)" />
		<path id="Rectangle_4414" fill="none" d="M0 0H48V48H0z" />
	</svg>
)
